import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildMainGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const appURL = buildMainGetterObject('appURL');
export const loading = buildMainGetterObject('loading');
export const appApiURL = buildMainGetterObject('appApiURL');
export const isExtensionLogin = buildMainGetterObject('isExtensionLogin');
export const isInExtensionIframe = buildMainGetterObject('isInExtensionIframe');
export const isFlowRun = buildMainGetterObject('isFlowRun');

const getters = {
	[appURL.getter]: () => {
		const { VUE_APP_APP_URL } = process.env;
		return VUE_APP_APP_URL;
	},
	[loading.getter]: (state) => state.loading,
	[appApiURL.getter]() {
		const { VUE_APP_API } = process.env;
		return VUE_APP_API;
	},
	[isExtensionLogin.getter]: () => {
		const urlParams = new URLSearchParams(window.location.search);
		const myParam = urlParams.get('extLogin');
		return myParam == 1;
	},
	[isInExtensionIframe.getter]: () => {
		const urlParams = new URLSearchParams(window.location.search);
		const myParam = urlParams.get('ext');
		return myParam == 1;
	},
	[isFlowRun.getter]: (state) => state.isFlowRun,
};

export default getters;
